/* eslint-disable camelcase */
import 'animate.css';

import { Grid } from '@mui/material';
import { VSpacer } from '@nx-smartmonkey/ui';

import DegradedBg from '../../../assets/img/onboarding/backgrounds/background-degraded-green.png';
import { useUpdateOrganizationOnboarding } from '../../../hooks/organization/useUpdateOrganizationOnboarding';
import Button from '../../../react-components/Button';
import Text from '../../../react-components/Text';
import { OnboardingContent } from '../Onboarding.styled';

export const Finish = () => {
  const { isLoading, run: updateOrganization } = useUpdateOrganizationOnboarding();

  return (
    <OnboardingContent
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      wrap="nowrap"
      style={{
        width: `100vw`,
        height: `100vh`,
        backgroundImage: `url(${DegradedBg})`,
        backgroundSize: `cover`,
      }}
      className="animate__animated animate__fadeIn"
    >
      <Grid
        item
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        className="animate__animated animate__fadeInUp"
      >
        <VSpacer medium />

        <Grid item style={{ maxWidth: `900px` }}>
          <Text style={{ textAlign: `center`, color: `white` }} variant="h5" intlId="company.onboarding.finish.text" />
        </Grid>

        <VSpacer large />

        <Grid item>
          <Button
            disabled={isLoading}
            styleType="secondary"
            intlId={isLoading ? `loading` : `company.onboarding.finish.button`}
            style={{
              width: `200px`,
              height: `32px`,
            }}
            onClick={() => {
              updateOrganization({ active: true });
            }}
          />
        </Grid>
      </Grid>
    </OnboardingContent>
  );
};
